var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103 456L103 484",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.5,
    cy: 451.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9875 451.19C98.9875 447.283 102.288 444.117 106.358 444.117C106.943 444.117 107.511 444.184 108.056 444.308C106.742 443.48 105.187 443 103.519 443C98.814 443 95 446.806 95 451.5C95 456.194 98.814 460 103.519 460C105.814 460 107.895 459.093 109.427 457.62C108.492 458.032 107.454 458.263 106.358 458.263C102.288 458.263 98.9875 455.096 98.9875 451.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.402 450.6L112.37 448.146L110.536 449.719L108.304 449.056L109.112 451.337L107.765 453.381L110.1 453.218L111.499 455.144L112.133 452.763L114.345 451.909L112.402 450.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.5e32560145bf2c30baa16dc33240c246.svg";
export { ForwardRef as ReactComponent };